export type QuoteSendType = "email" | "sms" | string;

export const normalizeSendType = (sendType?: string, smsType?: string): "email" | "sms" => {
  const normalized = (sendType || smsType)?.trim().toLowerCase();
  if (normalized === "sms") return "sms";
  return "email";
};

export const getSendOtpPromptText = (
  sendType?: string,
  smsType?: string
): string => {
  const type = normalizeSendType(sendType, smsType);

  if (type === "sms") {
    return "To verify this quote, we'll send a 6-digit OTP to your registered mobile number.";
  }

  return "To verify this quote, we'll send a 6-digit OTP to your registered email address.";
};

export const getOtpInstructionText = (
  sendType?: string,
  maskedContact?: string,
  smsType?: string
): { prefix: string; contact?: string } => {
  const type = normalizeSendType(sendType, smsType);

  if (type === "sms") {
    return {
      prefix: "Enter the 6-digit OTP sent to your registered mobile number",
      contact: maskedContact,
    };
  }

  return {
    prefix: "Enter the 6-digit OTP sent to your registered email address",
    contact: maskedContact,
  };
};

type QuoteDateSource = {
  createdOn?: string;
};

export const getQuoteSentDate = (
  quote?: QuoteDateSource | null,
  verifiedDetails?: QuoteDateSource | null
) => verifiedDetails?.createdOn ?? quote?.createdOn ?? null;
